<template lang="pug">
.popwin(ref="popwin" v-show="isPop")
    .bg(:style="`width:${pxToRem(Number(w)+40)};height:${pxToRem(Number(h)+40)}`" ref="popbg")
        video(:src="src" :style="`width:${pxToRem(w)};height:${pxToRem(h)}`" :loop="loop" muted autoplay ref="popv")
    slot
    

</template>

<script>
//- Pop.pop(
//-     ref='pop'
//-     w=960
//-     h=540
//-     :src="`${path}${lang}${popnam}.mp4`"
//- )
//-     .back(@click='onback()')
import gsap from 'gsap'
import basefunc from './basefunc'
export default {
    data(){
        return {
            isPop: false,
        }
    },
    props:{
        src: {default: ''},
        loop: {default: true},
        w: {default: 100},
        h: {default: 100},
    },
    mixins:[basefunc],
    mounted(){
        gsap.set(this.$refs.popwin,{alpha:0})
        gsap.set(this.$refs.popbg,{scale:0})
    },
    methods:{
        onback(bl){
            gsap.to(this.$refs.popwin,.5,{alpha:bl?0:1})
            gsap.to(this.$refs.popbg,.5,{scale:bl?0:1})
            if(!bl)this.isPop=!bl
            else{ 
                setTimeout(() => {
                    this.isPop=false
                }, 500)
            }
        },
        resetTime(){
            this.$refs.popv.currentTime=0
        },
        showPop(bl){
            this.onback(!bl)
            this.resetTime()
        }
    }
}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/edge'
.popwin
    +full()
    +pos(0,0)
    background: #000d
    display: flex
    align-items: center
    justify-content: center
    .bg
        position: absolute
        background: #0ff3
        border: solid 1px #0ff
        border-radius: pxToRem(60)
        // +size(1960,1120)
        video
            object-fit: contain
            // +size(1920,1080)
            margin: pxToRem(20)
            border-radius: pxToRem(60)
            border: solid 1px #0ff

</style>